const formatMax2 = (n: number) => {
  // format with up to 2 decimal places and trim trailing zeros
  return n.toFixed(2).replace(/\.?0+$/, "");
};

export const formatLargeMonetaryNumber: any = (number: number) => {
  if (number < 0) {
    return "-" + formatLargeMonetaryNumber(-1 * number);
  }

  if (number < 1000) {
    return "$" + formatMax2(number);
  } else if (number >= 1000 && number < 1_000_000) {
    return "$" + formatMax2(number / 1000) + "K";
  } else if (number >= 1_000_000 && number < 1_000_000_000) {
    return "$" + formatMax2(number / 1_000_000) + "M";
  } else if (number >= 1_000_000_000 && number < 1_000_000_000_000) {
    return "$" + formatMax2(number / 1_000_000_000) + "B";
  } else if (number >= 1_000_000_000_000 && number < 1_000_000_000_000_000) {
    return "$" + formatMax2(number / 1_000_000_000_000) + "T";
  }

  return "$" + formatMax2(number);
};

export const formatLargeNonMonetaryNumber: any = (number: number) => {
  if (number < 0) {
    return "-" + formatLargeNonMonetaryNumber(-1 * number);
  }

  if (number < 1000) {
    return formatMax2(number);
  } else if (number >= 1000 && number < 1_000_000) {
    return formatMax2(number / 1000) + "K";
  } else if (number >= 1_000_000 && number < 1_000_000_000) {
    return formatMax2(number / 1_000_000) + "M";
  } else if (number >= 1_000_000_000 && number < 1_000_000_000_000) {
    return formatMax2(number / 1_000_000_000) + "B";
  } else if (number >= 1_000_000_000_000 && number < 1_000_000_000_000_000) {
    return formatMax2(number / 1_000_000_000_000) + "T";
  }

  return formatMax2(number);
};

export const formatRatio = (ratio: number) => {
  return (Math.round(ratio * 100) / 100).toFixed(2);
};
